import type {
  ConsultationSituationKey,
  ConsultationSituationPalette,
  ConsultationSituationSegment,
  ConsultationsBillingMetrics,
} from "../types/consultationsBilling.types";

const SITUATION_ORDER: ConsultationSituationKey[] = [
  "overdueBooked",
  "closed",
  "booked",
  "fulfilled",
];

function pluralize(count: number, singular: string, plural: string): string {
  return count === 1 ? singular : plural;
}

export function buildConsultationSituationSegments(
  metrics: ConsultationsBillingMetrics,
  palette: ConsultationSituationPalette,
  formatCurrency: (value: number) => string
): ConsultationSituationSegment[] {
  return SITUATION_ORDER.map((key) => {
    const value = metrics[key];
    let subtitle: string | undefined;

    if (key === "booked" && metrics.pendingAmount && metrics.pendingAmount > 0) {
      subtitle = `${formatCurrency(metrics.pendingAmount)} aguardando pagamento`;
    }
    if (key === "fulfilled" && metrics.receivedAmount && metrics.receivedAmount > 0) {
      subtitle = `${formatCurrency(metrics.receivedAmount)} recebidos`;
    }
    if (key === "closed" && metrics.closedAmount && metrics.closedAmount > 0) {
      subtitle = `${formatCurrency(metrics.closedAmount)} em pagamentos não realizados`;
    }
    if (value > 0 && !subtitle) {
      subtitle = `${value} ${pluralize(value, "consulta", "consultas")}`;
    }

    return {
      key,
      label: palette.labels[key],
      description: palette.descriptions[key],
      value,
      color: palette.colors[key],
      status: palette.status[key],
      subtitle,
    };
  });
}

export function pickDefaultSituation(
  metrics: ConsultationsBillingMetrics
): ConsultationSituationKey {
  if (metrics.overdueBooked > 0) return "overdueBooked";
  if (metrics.closed > 0) return "closed";
  if (metrics.booked > 0) return "booked";
  if (metrics.fulfilled > 0) return "fulfilled";
  return "booked";
}
